import React, { useState, useRef, useEffect } from 'react';
import './Dropdown.css';
import nextIcon from '../../assets/nextIcon.png';
import arrowExpand from '../../assets/arrowExpand.png'

const Dropdown = ({ options, onSelect, buttonText, showSelected = false, closeSelect = false, closeDropdown }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [selectedOption, setSelectedOption] = useState('');

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleOptionClick = (option) => {
    onSelect(option);
    setSelectedOption(option.label);
    setIsOpen(false);
  };

  return (
    <div className="dropdown-container" ref={dropdownRef}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          {closeSelect && (
            <button
              className="dropdown-close-button"
              onClick={() => {
                setSelectedOption('');
                onSelect({ label: '', value: '' });
                closeDropdown();
              }}
            >
              ×
            </button>
          )}
          <button 
            className="dropdown-button" 
            onClick={() => setIsOpen(!isOpen)}
          >
            {showSelected && selectedOption ? selectedOption : buttonText}
            <img src={isOpen ? arrowExpand : nextIcon} alt="icon" className="dropdown-icon" />
          </button>
        </div>
      {isOpen && (
        <div className="dropdown-menu">
          {options.map((option, index) => (
            <button
              key={index}
              className="dropdown-item"
              onClick={() => handleOptionClick(option)}
            >
              {option.icon && <img src={option.icon} alt="" className="option-icon" />}
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
